// 관세사 — 미매칭 면장 업로드 수동 재매칭 (P2, 2026-06-01)
//   백엔드: GET /clearance-broker/unmatched, POST /unmatched/:id/assign{carId}, DELETE /unmatched/:id, GET /unmatched/:id/download
//   OCR VIN 매칭 실패한 면장을 관세사가 본인 큐(대기/신고중) 차량에 직접 배정.
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

var NAVY = '#1B3A5C';

function CustomsBrokerUnmatched({ showToast, onChange }) {
  var st = showToast || function () {};
  var itemsState = useState([]); var items = itemsState[0]; var setItems = itemsState[1];
  var carsState = useState([]); var cars = carsState[0]; var setCars = carsState[1]; // 배정 후보(대기+신고중)
  var pickState = useState({}); var pick = pickState[0]; var setPick = pickState[1]; // {unmatchedId: carId}
  var loadingState = useState(true); var loading = loadingState[0]; var setLoading = loadingState[1];

  function loadCandidates() {
    Promise.all(['대기', '신고중'].map(function (s) {
      return authFetch(API + '/clearance-broker/queue?status=' + encodeURIComponent(s)).then(function (r) { return r.json(); }).then(function (d) { return (d && d.items) || []; });
    })).then(function (lists) { setCars([].concat(lists[0], lists[1])); }).catch(function () {});
  }
  function load() {
    setLoading(true);
    authFetch(API + '/clearance-broker/unmatched').then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) setItems(d.items || []); setLoading(false); })
      .catch(function () { setLoading(false); });
    loadCandidates();
  }
  useEffect(function () { load(); }, []);

  function assign(it) {
    var carId = pick[it.id];
    if (!carId) { st('배정할 차량을 선택하세요', 'err'); return; }
    var car = cars.filter(function (c) { return c.carId === Number(carId); })[0];
    if (!window.confirm('이 면장을 ' + (car ? car.carNo : '') + ' 에 배정할까요? (면장완료 처리 + 업체 알림)')) return;
    authFetch(API + '/clearance-broker/unmatched/' + it.id + '/assign', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ carId: Number(carId) }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.success) { st('배정 완료 · 면장완료 처리됨', ''); setItems(function (p) { return p.filter(function (x) { return x.id !== it.id; }); }); if (onChange) onChange(); }
        else st((d && d.error) || '배정 실패', 'err');
      }).catch(function () { st('배정 실패', 'err'); });
  }
  function discard(it) {
    if (!window.confirm('이 미매칭 면장을 폐기할까요?')) return;
    authFetch(API + '/clearance-broker/unmatched/' + it.id, { method: 'DELETE' })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) { st('폐기됨', ''); setItems(function (p) { return p.filter(function (x) { return x.id !== it.id; }); }); if (onChange) onChange(); } else st((d && d.error) || '폐기 실패', 'err'); })
      .catch(function () { st('폐기 실패', 'err'); });
  }
  function download(it) {
    authFetch(API + '/clearance-broker/unmatched/' + it.id + '/download')
      .then(function (r) { if (!r.ok) throw new Error('not ok'); return r.blob(); })
      .then(function (blob) {
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a'); a.href = url; a.download = it.originalName || ('myunjang_' + it.id + '.pdf');
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { try { URL.revokeObjectURL(url); } catch (e) {} }, 1000);
      }).catch(function () { st('다운로드 실패', 'err'); });
  }

  return (
    <div>
      <div style={{ fontSize: 12, color: '#64748b', marginBottom: 12 }}>{'OCR VIN 매칭에 실패한 면장입니다. 내용을 확인하고 큐의 차량을 골라 직접 배정하세요. (배정 시 면장완료 + 업체 알림)'}</div>
      {loading && <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>{'불러오는 중...'}</div>}
      {!loading && items.length === 0 && (
        <div style={{ padding: 50, textAlign: 'center', color: '#94a3b8', background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb' }}>
          <div style={{ fontSize: 32, opacity: 0.4 }}>{'✅'}</div>
          <div style={{ marginTop: 8 }}>{'미매칭 면장이 없습니다'}</div>
        </div>
      )}
      {!loading && items.map(function (it) {
        return (
          <div key={it.id} style={{ background: '#fff', border: '1px solid #fde68a', borderLeft: '4px solid #f59e0b', borderRadius: 10, padding: '12px 16px', marginBottom: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
              <div style={{ flex: 1, minWidth: 220 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: NAVY }}>{'📄 ' + (it.originalName || ('면장 #' + it.id))}</div>
                <div style={{ fontSize: 12, color: '#64748b', marginTop: 3 }}>{'OCR VIN: ' + (it.vins || '-') + (it.exportDecNo ? '  ·  신고번호: ' + it.exportDecNo : '')}</div>
                <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>{'업로드: ' + (it.createdAt || '')}</div>
                <button onClick={function () { download(it); }} style={{ marginTop: 6, padding: '3px 10px', border: '1px solid #cbd5e1', background: '#f8fafc', color: NAVY, borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: 'pointer' }}>{'⬇️ 면장 확인'}</button>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 220 }}>
                <select value={pick[it.id] || ''} onChange={function (e) { var v = e.target.value; setPick(function (p) { return Object.assign({}, p, { [it.id]: v }); }); }}
                  style={{ padding: '7px 10px', borderRadius: 8, border: '1px solid #cbd5e1', fontSize: 12 }}>
                  <option value="">{'배정할 차량 선택'}</option>
                  {cars.map(function (c) { return <option key={c.id} value={c.carId}>{c.carNo + ' · ' + (c.vin || '').slice(-6) + ' (' + c.companyName + ')'}</option>; })}
                </select>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button onClick={function () { assign(it); }} style={{ flex: 2, padding: '7px', background: '#16a34a', color: '#fff', border: 'none', borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>{'✅ 배정'}</button>
                  <button onClick={function () { discard(it); }} style={{ flex: 1, padding: '7px', background: '#f1f5f9', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{'폐기'}</button>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default CustomsBrokerUnmatched;
